import { useMemo } from 'react';
import { ListChecks } from 'lucide-react';
import { MultipleChoiceFilter } from '@duke-hq/ui/components/MultipleChoice/MultipleChoiceFilter';
import useFiltersContext from '@duke-hq/filters/context/useFiltersContext';
import { iconSize } from '@duke-hq/ui/constants/scalable';

const STATUS_OPTIONS = [
  { id: 'COMPLETED', value: 'COMPLETED', label: 'Completed' },
  { id: 'PENDING', value: 'PENDING', label: 'Pending' },
  { id: 'FAILED', value: 'FAILED', label: 'Failed' },
  { id: 'ABORTED', value: 'ABORTED', label: 'Aborted' },
];

export function StatusFilter() {
  const { updateFilters, filters } = useFiltersContext();

  const selected = useMemo(() => {
    const fileStatus = filters['fileStatus'] ?? [];
    const validIds = new Set(STATUS_OPTIONS.map(({ id }) => id));
    return fileStatus.filter((id: string) => validIds.has(id));
  }, [filters]);

  return (
    <MultipleChoiceFilter
      items={STATUS_OPTIONS}
      label="Upload Status"
      name="fileStatus"
      onFilterChange={({ fileStatus }) => updateFilters({ fileStatus })}
      onlyUpdateOnChange
      value={selected.join(',')}
      variant="ghost"
      leftIcon={<ListChecks size={iconSize.md} />}
      rightIcon={undefined}
    />
  );
}
